module.exports = __webpack_public_path__ + "b5170bdea66f17f6dd71fd39b78f909b.svg";